import $ from "jquery";
import { Modal } from 'bootstrap'

document.addEventListener('DOMContentLoaded', function() {

    function getLargestImageFromSrcset(srcset) {
        let srcsetArray = srcset.split(',');
        let largestImage = '';
        let largestWidth = 0;

        srcsetArray.forEach(function(item) {
            let parts = item.trim().split(' ');
            let url = parts[0];
            let width = parseInt(parts[1].replace('w', ''));

            if (width > largestWidth) {
                largestWidth = width;
                largestImage = url;
            }
        });

        return largestImage;
    }
    
    // GALLERY AND SINGLE PHOTO INSIDE WYSIWYG EDITOR

    if ($('.gallery').length > 0) {
        $('.gallery .gallery-item a').each(function() {
            var $this = $(this);
            var hrefUrl = $this.attr('href');
            $this.attr('data-bs-toggle', 'modal');
            $this.attr('data-bs-target', '#galleryModal');
            $this.attr('data-image', hrefUrl);
        });
    }

    // $('.wp-caption a').each(function() {
    //     const $this = $(this);
    //     const image = $this.find('img');
    //     const srcset = image.attr('srcset');
    //     const largestImage = getLargestImageFromSrcset(srcset);

    //     $this.attr('data-bs-toggle', 'modal');
    //     $this.attr('data-bs-target', '#galleryModal');
    //     $this.attr('data-image', largestImage);
    // });

    $('#galleryModal').on('show.bs.modal', function (event) {
        const button = $(event.relatedTarget);
        const image = button.data('image');

        const modal = $(this);
        modal.find('.modal-body img').attr('src', image);
    });

});